import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import RecorderBlockEditing from './recorder/recorderblockediting';
import './theme/recorder.css';

export default class RecorderBlock extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [ RecorderBlockEditing, Widget ];
    }

    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'RecorderBlock';
    }
}
